import { Directive } from '@angular/core';

@Directive({
  selector: '[wcgInlineViewMode]',
})
export class ViewModeDirective {}
